import { Store, select, State } from '@ngrx/store';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
  AppState,
  MyCollectionActionTypes,
  SwitchProfileActionTypes,
  UserActionTypes,
  selectPatientId,
  selectProfile,
  selectSwitchProfile,
  selectUser,
} from '@app/core/ngrx';
import { NavigationService } from '@app/core/services/navigation.service';
import { LoginDialogComponent } from '@app/shared/components';
import { BrowserGlobalRef } from '@app/shared/global-ref';
import { AppMenuItems, UserMenuItems } from '@app/shared/data/navigation.data';
import { MenuItem, User } from '@app/core/models';
import { combineLatest, Subscription } from 'rxjs';
import { Observable } from 'rxjs';
import { UserService } from '@app/core/services';

@Component({
  selector: 'ecp-portal',
  templateUrl: './portal.component.html',
  styleUrls: ['./portal.component.scss'],
  standalone: false,
})
export class PortalComponent implements OnInit, OnDestroy {
  /**
   * subscription$
   */
  private subscription$: Subscription;
  /**
   * menu
   */
  public menu: any = {
    app: [],
    user: [],
  };

  /**
   * appNav
   */
  public appNav: MenuItem[] = AppMenuItems;
  /**
   * userNav
   */
  public userNav: MenuItem[] = UserMenuItems;
  public patientId$: Observable<string>;
  public superUserData: any;

  constructor(
    private store: Store<AppState>,
    private navigationService: NavigationService,
    private _global: BrowserGlobalRef,
    public dialog: MatDialog,
    private state$: State<AppState>,
    private userService: UserService,
  ) {
    this.getUser();
  }
  getUser() {
    this.subscription$ = combineLatest([
      this.store.select(selectUser),
      this.store.select(selectSwitchProfile),
    ]).subscribe(([userState, prof]) => {
      if (userState.loaded) {
        const user = userState.profile;
        //Get EcpRole and location
        let navItems = this.appNav.filter(ap => {
          return ap.order !== 7;
        });
        this.superUserData = user.ecpRole;
        if (user.ecpRole === 'superuser') {
          if (
            prof.account !== null &&
            prof.account.toLowerCase().trim() !==
              user.account.toLowerCase().trim()
          ) {
            this.store.dispatch({
              type: UserActionTypes.LOAD_USER_SUCCESS,
              payload: prof,
            });
            this.store.dispatch({
              type: MyCollectionActionTypes.CLEAR_MY_COLLECTION,
            });
          }
          this.appNav = this.showNotif(AppMenuItems, user);
        } else {
          this.appNav = this.showNotif(navItems, user);
        }
        // console.log(this.appNav);
        if (userState.patientID) {
          this.setupPatientNavigation(userState.patientID);
          if (!user.isPremiumMember) {
            this.menu.app.splice(1, 1); // Remove MyFavorites link from patient portal if the ECP is not  a premium member
          }
        } else {
          // only display the navigation if the user is loaded
          this.setupNavigationItems();
          if (!user.isPremiumMember) {
            let index = this.menu.app.findIndex(element => {
              if (element.label === 'Patient Cart') {
                return true;
              }
            });
            if (index !== -1) this.menu.app.splice(index, 1); // Remove MyCart if the ECP is not a premium member

            // Temporary fix to enable Frame To Come for FOF only for initial launch.
            let subMenu = this.menu.app[2].children;
            if (
              user.program.programKey !== 'FOF' &&
              user.program.programKey !== 'VWFD' &&
              user.program.programKey !== 'PERC'
            ) {
              let idx = subMenu.findIndex(element => {
                if (element.label === 'Frame to Come') {
                  return true;
                }
              });
              if (idx !== -1) subMenu.splice(idx, 1); // Remove Frame To Come if the ECP is not a FOF && Premium
            }
          }
        }
      }
    });

    this.patientId$ = this.store.select(selectPatientId);
  }
  showNotif(menuItem: any, user) {
    return menuItem.map(menu => {
      if (menu.label === 'My Returns') {
        menu.hasNotif = user.returnNotification;
      }
      return { ...menu };
    });
  }
  ngOnInit() {}

  setupNavigationItems(): void {
    this.menu = {
      app: this.appNav,
      user: this.userNav,
    };
  }

  setupPatientNavigation(patientId) {
    this.menu = {
      app: [
        {
          label: 'Catalog',
          link: '/' + patientId,
          order: 1,
        },
        {
          label: 'My Favorites',
          link: '/' + patientId + '/shopping-cart',
          order: 2,
        },
      ],
    };
  }

  openLoginDialog(event): void {
    this.dialog.open(LoginDialogComponent, {
      width: '345px',
      maxWidth: '89.3vw',
      maxHeight: '82vh',
    });
  }
  switchLocation(ev: any): void {
    this.store.dispatch({
      type: SwitchProfileActionTypes.SWITCH_PROFILE,
      payload: ev.trim(),
    });
  }
  ngOnDestroy(): void {
    this.subscription$.unsubscribe();
  }
}
